import React, { useRef, useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import GuruMessage from './GuruMessage'
import GuruToolIndicator from './GuruToolIndicator'
import MarkdownRenderer from 'components/MarkdownRenderer'
import LogoShort from 'assets/images/bp-logo-orange.png'

const Container = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
`

const GuruMessageList = ({ messages, isLoading, toolStatus, streamingText, userPhoto, onConfirmAction, onCancelAction, onOpenInsight, portfolioId, bpNameById }) => {
  const endRef = useRef(null)
  const containerRef = useRef(null)
  const hasConversedRef = useRef(false)

  useEffect(() => {
    if (isLoading || streamingText) hasConversedRef.current = true

    const container = containerRef.current
    if (container) container.scrollTop = container.scrollHeight

    if (hasConversedRef.current) {
      endRef.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  }, [messages, isLoading, streamingText])

  return (
    <Container ref={containerRef}>
      {messages.map((msg, i) => {
        // For sharing: pair an assistant answer with the immediately-preceding
        // user question. We pass it as a prop so GuruMessage can include both
        // in the share payload without needing access to the full message list.
        const precedingUserMessage = msg.role === 'assistant'
          ? [...messages].slice(0, i).reverse().find(m => m.role === 'user')
          : null
        return (
          <GuruMessage
            key={i}
            message={msg}
            precedingUserMessage={precedingUserMessage}
            userPhoto={userPhoto}
            onConfirmAction={onConfirmAction}
            onCancelAction={onCancelAction}
            onOpenInsight={onOpenInsight}
            portfolioId={portfolioId}
            bpNameById={bpNameById}
          />
        )
      })}
      {streamingText ? (
        <StreamRow>
          <AvatarWrapper><Avatar src={LogoShort} alt='Guru' /></AvatarWrapper>
          <StreamBubble>
            <MarkdownRenderer content={streamingText} />
            <Cursor />
          </StreamBubble>
        </StreamRow>
      ) : (isLoading && <GuruToolIndicator status={toolStatus} />)}
      <div ref={endRef} />
    </Container>
  )
}

export default GuruMessageList

const StreamRow = styled.div`
  display: flex;
  gap: 16px;
  padding: 12px 16px;
  align-items: flex-start;
`
const AvatarWrapper = styled.div`
  margin-top: 4px;
`
const Avatar = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
  flex-shrink: 0;
  @media (max-width: 768px) { width: 28px; height: 28px; }
`
const StreamBubble = styled.div`
  background-color: #f7f7f8;
  border-radius: 8px;
  padding: 10px 14px;
  min-width: 0;
  font-size: 14px;
  color: #1d2433;
`
const blink = keyframes`0%,100%{opacity:1}50%{opacity:0}`
const Cursor = styled.span`
  display: inline-block;
  width: 7px;
  height: 14px;
  margin-top: 2px;
  vertical-align: text-bottom;
  background: #f57c00;
  animation: ${blink} 1s steps(2) infinite;
`
